import React from 'react';
import { Box, Button, Typography } from '@mui/material';

import CustomModal from '../CustomModal';

const DataExportModal = ({ show, onHide, emailRecipient }) => (
  <CustomModal title="Exporting to Email" open={show} handleClose={onHide}>
    <Typography gutterBottom>
      The requested report will be sent to your email: {emailRecipient}
    </Typography>

    <Box sx={{ display: 'flex', justifyContent: 'end' }}>
      <Button variant="contained" color="secondary" onClick={onHide}>
        Close
      </Button>
    </Box>
  </CustomModal>
);

export default DataExportModal;
